import {SujetoExcluido} from '../interfaces/sujeto-excluido.interface'

export const sujetoExcluidoInitialState: SujetoExcluido = {
  formCliente: {
    fecha: new Date().toLocaleDateString('en-CA'),
    tipoDocumento: '',
    nombreTipoDocumento: '',
    numId: '',
    nombre: '',
    departamento: '',
    nombreDepartamento: '',
    municipio: '',
    nombreMunicipio: '',
    direccion: '',
    email: '',
    chipsEmail: [],
    telefono: '',
    condicion: '',
    checkReteRenta: false
  },
  errorsFormCliente: {
    fecha: '',
    tipoDocumento: '',
    numId: '',
    nombre: '',
    departamento: '',
    municipio: '',
    direccion: '',
    email: '',
    telefono: '',
    condicion: '',
  },
  formProductos: {
    tipo: 'p',
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: 'porcentaje',
    descuento: '0',
    cantidadDescuento: '0.00',
    subtotal: '0.00',
    total: '0.00',
    totalImpuesto1: '0.00',
    totalImpuesto2: '0.00',
    impuesto1: '0.00',
    impuesto2: '0.00',
    totalConImpuesto1: '0.00',
    subTotalConImpuesto1: '0.00',
    totalConImpuesto1Desc: '0.00',
    unidadMedida: '59'
  },
  errorsFormProductos: {
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: '',
    descuento: '',
    cantidadDescuento: '',
    subtotal: '',
    total: '',
  },
  formSucursal: {
    sucursal: '',
    serie: '',
    datosSucursal: null,
    datosSerie: null,
  },
  errorsFormSucursal: {
    sucursal: '',
    serie: '',
  },
  productoSeleccionado: null,
  productoEdit: {
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: 'porcentaje',
    descuento: '',
    cantidadDescuento: '0.00',
    subtotal: '0.00',
    total: '0.00',
    totalImpuesto1: '0.00',
    totalImpuesto2: '0.00',
    impuesto1: '0.00',
    impuesto2: '0.00',
    totalConImpuesto1: '0.00',
    subTotalConImpuesto1: '0.00',
    totalConImpuesto1Desc: '0.00',
  },
  formProductosEdit: {
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: 'porcentaje',
    descuento: '',
    cantidadDescuento: '0.00',
    subtotal: '0.00',
    total: '0.00',
  },
  errorsFormProductosEdit: {
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: '',
    descuento: '',
    cantidadDescuento: '',
    subtotal: '',
    total: '',
  },
  arrayProductos: [],
  calculosArrayProductos: {
    subtotal: '0.00',
    descuento: '0.00',
    total: '0.00',
    totalCantidad: '0.00',
    totalImpuesto1: '0.00',
    totalImpuesto2: '0.00',
    subTotalConImpuesto1: '0.00',
    totalConImpuesto1: '0.00',
    totalConRetecion: '0.00',
    totalIvaPercibido: '0.00',
    totalRetencionRenta: '0.00',
    totalMontoOperacion: '0.00',
    totalPagar: '0.00',
  },
  modals: {
    activeQuitarTodo: false,
    activeEliminarUno: false,
    activeEditar: false,
    activeEmitirFactura: false,
    activeFacturaEmitida: false,
    activeImpresion: false,
    activeEmail: false,
    activeAnular: false,
  },
  datosEmisor: {},
  datosFacturaRes: {},
  facturaEmitda: false,
  opcionesActiva: false,
  catalogoSucursal: [],
  catalogoSerie: [],
  datosUUID: null,
  anulado: false,
  sucursalesCargadas: false,
  formObservaciones: {
    referencia: '',
    observaciones: '',
    mostrarObservacionesPdf: true,
    incluirObservacionesCorreo: true,
  },
}

export const sujetoExcluidoInitialState2 = JSON.parse(JSON.stringify(sujetoExcluidoInitialState))